module.exports = __webpack_public_path__ + "static/img/tzll.a4a336b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tzll.png
// module id = V60Y
// module chunks = 2